export default __webpack_public_path__ + "static/media/KKannaBabuIAS.8362e326.png";